import React from 'react';
import PropTypes from 'prop-types';
import LabelledCheckbox from '../LabelledCheckbox';
import {omit, isEmpty, T, anyPass} from 'ramda';

const CheckboxFilter = ({label, filters, style, onChange, ...props}) => {
  return (
    <div
      style={{display: 'flex', alignItems: 'center', ...style}}
      {...omit(['filterName'], props)}
    >
      {label && <span style={{marginRight: '15px'}}>{label}</span>}
      {filters.map(filter => (
        <LabelledCheckbox
          key={filter.label}
          label={filter.label}
          checked={filter.checked}
          onChange={() => onChange(filter.label)}
          color={filter.color}
          id={`gtm-filter-${filter.label.toLowerCase()}`}
        />
      ))}
    </div>
  );
};

CheckboxFilter.propTypes = {
  filterName: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      color: PropTypes.string,
    }),
  ).isRequired,
  style: PropTypes.object,
};

export const compileCheckboxFilter = filters =>
  isEmpty(filters) ? T : anyPass(filters.filter(x => x.checked).map(x => x.fn));

export default CheckboxFilter;
